<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <ValidationObserver ref="FormLogin" v-slot="{ validate, handleSubmit, invalid, validated }">
              <v-form>
                <v-card class="elevation-12 mx-auto pt-10">
                  <v-img
                      class="white--text align-end"
                      height="110px"
                      contain
                      :src="require('~/assets/logo.svg')"
                  />
                  <v-card-text>
                    <v-sheet v-for="errors in form.errors" v-if="errors">
                      <v-alert type="error" v-for="error in errors" dismissible close-icon="mdi-close-thick">
                        {{ error }}
                      </v-alert>
                    </v-sheet>

                    <TextInput
                        required
                        label="login"
                        prepend-icon="mdi-account"
                        rules="required|email"
                        v-model="email"
                        :errors="form.errors.email"
                    />
                    <TextInput
                        required
                        label="password"
                        prepend-icon="mdi-lock"
                        rules="required"
                        type="password"
                        v-model="password"
                        :errors="form.errors.password"
                    />

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        text
                        :disabled="invalid || !validated"
                        @click="handleSubmit(submit)"
                    >
                      Login
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {ValidationObserver} from 'vee-validate';
import TextInput from "~/views/layouts/forms/TextInput";
import upperFirst from 'lodash/upperFirst';

export default {
  components: {
    TextInput,
    ValidationObserver,
  },
  data: () => ({
    email: '',
    password: '',
    form: {
      errors: {
        email: null,
        messages: null,
        password: null
      }
    }
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('profile');
    }
  },
  methods: {
    submit() {
      let email = this.email
      let password = this.password
      this.$store.dispatch('auth/login', {email, password})
          .then(() => this.$router.push({name: 'dashboard'}))
          .catch(({meta, errors}) => {
            if (meta) {
              this.form.errors.messages = [this.$t(`api['${meta.message}']`)];
            }
            if (errors) {
              for (let error in errors) {
                if (errors.hasOwnProperty(error)) {
                  if (Array.isArray(errors[error])) {
                    this.form.errors[error] = errors[error].map(msg =>
                        upperFirst(this.$t(`api['${msg}']`).toLowerCase())
                    );
                  } else {
                    this.form.errors.messages.push(this.$t(`api['${errors[error]}']`))
                  }
                }
              }
            }
          })
    }
  }
};
</script>